import React from 'react'
import type { StaticGroup, TileLayoutConfig } from '../types'
import { BadgeList, Card, Icon, NavigationLink } from '../components/components-lib'
import { ResourceImage } from '../components/resource-image'
import { TileCard } from '../components/tile-card'
import { useTranslation } from 'react-i18next'
import { faLocationDot } from '@fortawesome/free-solid-svg-icons'
import { MainStylesVars } from '../stylesheet'
import { FixedWidthList } from '../components/fixed-width-list'
import { groupTagsByCategory } from '../../../services/tags'
import { useLang } from '../chapito-static'
import type { Genre } from '../../../grab/types'

export function GuestsCompactList(props: { guests: StaticGroup[]; cardsPerRow?: number; tileLayout?: TileLayoutConfig }): JSX.Element {
  const { guests, tileLayout } = props
  return (
    <FixedWidthList itemsPerRow={props.cardsPerRow ?? 2}>
      {guests.map((g) =>
        tileLayout ? (
          <TileCard key={g._id} guest={g} tileLayout={tileLayout} navLink={{ page: 'guest', guestId: g._id }} style={{ height: '100%' }} />
        ) : (
          <GuestCardCompact key={g._id} guest={g} />
        )
      )}
    </FixedWidthList>
  )
}

function GuestCardCompact(props: { guest: StaticGroup }): JSX.Element {
  const { t } = useTranslation()
  const lang = useLang()
  const { guest } = props
  const tags = groupTagsByCategory(guest.genres ?? [], { lang })
  const tagLabels =
    tags.length > 1
      ? tags.map(({ category: { name: catName }, genres }: { category: { name: string }; genres: Genre[] }) => {
          const tagsForCat = genres.map(({ name }: { name: string }) => name).join(', ')
          return `${catName ? catName + ' : ' : ''}${tagsForCat}`
        })
      : tags.flatMap(({ genres }: { genres: Genre[] }) => genres.map(({ name }: { name: string }) => name))
  return (
    <NavigationLink style={{ display: 'grid' }} path={{ page: 'guest', guestId: guest._id }}>
      <Card style={{ padding: 10, display: 'flex', flexDirection: 'column', gap: 10 }}>
        <h3 style={{ marginBlock: 0 }}>{guest.name}</h3>
        <div style={{ display: 'flex', gap: 10 }}>
          <ResourceImage
            imageId={guest.image}
            alt={t('GENERAL.IMAGE_ALT_GUEST', { guest: guest.name })}
            style={{
              width: 90,
              borderRadius: 10,
              overflow: 'hidden',
              marginBlock: 'auto',
            }}
          />
          <div>
            {tagLabels.length > 0 && <BadgeList size="small" labels={tagLabels} />}

            {guest.location && (
              <p>
                <Icon color={MainStylesVars.colorBlockText} icon={faLocationDot} />
                {guest.location.join(', ')}
              </p>
            )}
          </div>
        </div>
      </Card>
    </NavigationLink>
  )
}
